module.exports = __webpack_public_path__ + "assets/img/api.ad702d5d.svg";